import NewBusinessApplicationAddBuildingPopup from './NewBusinessApplicationAddBuildingPopup';
import NewBusinessApplicationAddMortgageePopup from './NewBusinessApplicationAddMortgageePopup';
import NewBusinessApplicationCoordinatesSelectionCommercialPopup from './NewBusinessApplicationCoordinatesSelectionCommercialPopup';
import NewBusinessApplicationCoordinatesSelectionPersonalPopup from './NewBusinessApplicationCoordinatesSelectionPersonalPopup';
import NewBusinessApplicationEditBuildingAddressPopup from './NewBusinessApplicationEditBuildingAddressPopup';
import NewBusinessApplicationEditMortgageePopup from './NewBusinessApplicationEditMortgageePopup';
import NewBusinessApplicationOfacNotificationPopup from './NewBusinessApplicationOfacNotificationPopup';
import NewBusinessApplicationResubmitPopup from './NewBusinessApplicationResubmitPopup';
import NewBusinessApplicationSwitchToLegacyVersionConfirmationPopup from './NewBusinessApplicationSwitchToLegacyVersionConfirmationPopup';

export {
	NewBusinessApplicationAddBuildingPopup,
	NewBusinessApplicationAddMortgageePopup,
	NewBusinessApplicationCoordinatesSelectionCommercialPopup,
	NewBusinessApplicationCoordinatesSelectionPersonalPopup,
	NewBusinessApplicationEditBuildingAddressPopup,
	NewBusinessApplicationEditMortgageePopup,
	NewBusinessApplicationOfacNotificationPopup,
	NewBusinessApplicationResubmitPopup,
	NewBusinessApplicationSwitchToLegacyVersionConfirmationPopup,
};